<template>
    <div id="menuPage" class="page">
        <menu-button link="game" is-primary>Start Spel</menu-button>
        <menu-button link="settings" >Instellingen</menu-button>
    </div>
</template>

<script>
    import MenuButton from "../components/MenuButton";

    export default {
        name: "MenuPage",
        components: {
            MenuButton
        }
    }
</script>

<style scoped>

</style>